var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Dash-stories-feed-sort-panel'),_c('div',{staticClass:"one-page"},[_c('div',{staticClass:"panel"},[_c('ul',{staticClass:"posts stories"},_vm._l((_vm.page.stories),function(story){return _c('Dash-stories-card',{key:story.stat.id,attrs:{"story":story}})}),1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }